import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetDate = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.date} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetDate.muiName = "StatisticWidgetDate";
StatisticWidgetDate.displayName = "StatisticWidgetDate";

export default StatisticWidgetDate;
